import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from '@us/web/shared/data-access';
import { Shop } from '@us/web/shared/data-access';
import { identity, pickBy } from 'lodash';
import { convertShopOption } from '@us/web/shared/utils';
// import { injectQuery } from '@ngneat/query';

@Injectable({
    providedIn: 'root'
})
export class ShopService {
    private readonly apiService = inject(ApiService);
    // private readonly query = injectQuery();

    getShopInfo(params: { shop_id?: string; lat?: number; lng?: number }): Observable<Shop> {
        return this.apiService.get('shop/info', { params: pickBy(params, identity) }).pipe(
            map(shop => ({
                ...shop,
                options: convertShopOption(shop.options)
            }))
        );
    }

    // getShopInfoQuery(params: { shop_id?: string; lat?: number; lng?: number }) {
    //     return this.query({
    //         queryKey: ['shop-info', params] as const,
    //         queryFn: () => this.getShopInfo(params)
    //     });
    // }

    getListShops(params: { shop_id?: string; lat?: number; lng?: number }): Observable<Shop[]> {
        return this.apiService.get<Shop[]>(`shop/chain`, { params: pickBy(params, identity) }).pipe(
            map(shops =>
                shops.map(shop => ({
                    ...shop,
                    options: convertShopOption(shop.options)
                }))
            )
        );
    }
}
